import React, { useState, useContext } from 'react';
import EmployeeModal from '../EmployeeModal/EmployeeModal';
import ContactIcon from './ContactIcon';
import SearchIcon from 'oldAssets/images/icons/search-white.svg';
import { WunderAgentsContext } from '../../TeamPage';
import styles from './PhotoAndContact.module.scss';

/*eslint max-lines-per-function: ["error", 100]*/
const PhotoAndContact = ({ employee, contacts, isManager, size = 210 }) => {
  const { more, button } = useContext(WunderAgentsContext);

  const [show, setShow] = useState(false);
  const mainClasses = `${ styles.PhotoAndContact } ${ isManager ? styles.manager : styles.employee }`;
  const { photo, name } = employee;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const employeeModalProps = { show, employee, contacts, button, handleClose };

  return (
    <div className={ mainClasses }>
      <figure>
        <img src={ photo } width={ size }
          height={ size }
        />
        { !isManager && more &&
          <React.Fragment>
            <div className={ styles.moreInfo }
              onClick={ handleShow }
            >
              <img src={ SearchIcon } width="25"
                height="25"
              />
              <p>{ more }</p>
              <p>{ name }</p>
            </div>
            <EmployeeModal { ...employeeModalProps } />
          </React.Fragment>
        }
      </figure>
      <div className = { styles.social }>
        {
          contacts &&
          contacts.filter(contact => contact.link !== null && contact.link !== 'mailto:null')
                  .map((contact, i) => <ContactIcon key = { i } { ...contact } /> )
        }
      </div>
    </div>
  );
};

export default PhotoAndContact;
